import React, { useEffect, useState } from "react";
import { api } from "@/lib/api";

const gbp = (v) => (v == null ? "-" : `£${Math.round(Number(v)).toLocaleString()}`);

export const OptimizerCard = () => {
  const [data, setData] = useState({ runs: [], active: [] });
  useEffect(() => {
    api.get("/mt5admin/brain/optimizations?limit=20").then((r) => setData(r.data)).catch(() => {});
  }, []);
  return (
    <div data-testid="optimizer-card" className="mt-8 border border-[#22D3EE]/30 rounded-lg overflow-hidden bg-[#0B0D14]">
      <div className="px-5 py-3 border-b border-[#22D3EE]/30 flex flex-wrap items-center justify-between gap-2">
        <div className="text-lg font-medium">Genetic optimiser</div>
        <div className="mono text-[10px] uppercase tracking-widest text-[#64748B]">
          1 optimisation per symbol every 5 backtests · top 5 combos re-tested on real ticks
        </div>
      </div>
      {data.paused_until && (
        <div data-testid="optimizer-paused" className="px-5 py-2 mono text-xs text-[#FBBF24] border-b border-[#111827]">
          Paused after 3 failed runs in a row - resumes {String(data.paused_until).slice(5, 16).replace("T", " ")} UTC
        </div>
      )}
      {data.active.map((a) => (
        <div key={a.bot_name} data-testid={`optimizer-active-${a.symbol}`} className="px-5 py-2 mono text-xs text-[#22D3EE] border-b border-[#111827]">
          {a.status === "picked_up" ? "running now" : "queued"}: {a.symbol} around {a.parent_bot}
        </div>
      ))}
      {data.runs.length === 0 ? (
        <div className="p-6 mono text-xs text-[#64748B]" data-testid="optimizer-empty">No optimisations yet - needs VPS scripts v61.</div>
      ) : (
        <div className="overflow-x-auto">
          <table className="w-full mono text-[11px] whitespace-nowrap">
            <thead>
              <tr className="text-[10px] uppercase tracking-widest text-[#64748B] border-b border-[#1F2937]">
                {["When", "Symbol", "Around", "Passes", "Best fast-mode £", "Trades", "DD %", "Minutes", "Status"].map((h) => (
                  <th key={h} className="text-left px-3 py-2">{h}</th>
                ))}
              </tr>
            </thead>
            <tbody>
              {data.runs.map((r) => {
                const t = (r.top || [])[0] || {};
                return (
                  <tr key={r.task_id} data-testid={`optimizer-row-${r.task_id}`} className="border-b border-[#111827] hover:bg-[#111827] transition-colors">
                    <td className="px-3 py-2 text-[#94A3B8]">{String(r.ts || "").slice(5, 16).replace("T", " ")}</td>
                    <td className="px-3 py-2">{r.symbol} {r.period}</td>
                    <td className="px-3 py-2 text-[#94A3B8]">{r.parent_bot}</td>
                    <td className="px-3 py-2">{r.passes}</td>
                    <td className="px-3 py-2 text-[#2ECA7F]">{gbp(t.profit)}</td>
                    <td className="px-3 py-2">{t.trades ?? "-"}</td>
                    <td className="px-3 py-2">{t.dd ?? "-"}</td>
                    <td className="px-3 py-2">{r.seconds ? (r.seconds / 60).toFixed(0) : "-"}</td>
                    <td className="px-3 py-2 max-w-[420px] whitespace-normal" style={{ color: r.error ? "#F87171" : "#2ECA7F" }}
                      data-testid={`optimizer-status-${r.task_id}`}>
                      {r.error ? r.error : `${(r.top || []).length} verifying`}
                      {r.log && (
                        <details className="mt-1 text-[10px] text-[#FBBF24]">
                          <summary className="cursor-pointer" data-testid={`optimizer-log-toggle-${r.task_id}`}>MT5 log</summary>
                          <div className="break-all" data-testid={`optimizer-log-${r.task_id}`}>{r.log}</div>
                        </details>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      )}
    </div>
  );
};
